import React from "react";
import { validateEmail } from "../../utils/utils";
import Loading from "../Loading";
import usuariosStore from "../../stores/UsuariosStore";
import Modal from 'react-bootstrap/Modal';

export default class UsuarioRecover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mail: '',
            cargando: false,
            error: '',
            ok: false
        };
    }

    async register() {
        this.setState({error: ''});
        const { mail } = this.state;

        if (!this.state['mail']) {
            this.setState({error: "Ingrese una direccion de email válida."})
            return;
        }

        if (!validateEmail(mail)) {
            this.setState({error: "Ingrese una direccion de email válida."})
            return;
        }

        this.setState({cargando: true});

        const ok = await usuariosStore.recoverPassword(mail);
        if (!ok) {
            this.setState({error: "Hubo un error al intentar recuperar la clave, intente nuevamente."});
            this.setState({cargando: false, ok: false});
        } else {
            this.setState({error: "Se envió un mail con su nueva clave."})
            this.setState({cargando: false, ok: true});
        }
    }

    update({target}) {
        const value = target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    render() {
        const { mail, error, ok, cargando } = this.state;
        return (
            <>
                <Modal.Header>
                    <h4 className="modal-title " id="">Recupero de Contraseña</h4>
                    <button type="button" className="btn-close" aria-label="Close" onClick={() =>
                        usuariosStore.showRecoverModal(false)
                    }></button>
                </Modal.Header>
                <div className={"modal-body"}>
                    <div className={"login"}>
                        {!ok &&
                            <>
                                <div className={"mb-3"}>
                                    <label className={"form-label"}> E-Mail </label>
                                    <input className="form-control" type={'text'} value={mail} name={'mail'} onChange={(e) => {
                                        this.update(e)
                                    }}/>
                                </div>

                                <div className={"row mt-5 d-flex justify-content-center"} style={{marginBotom: '100px'}}>
                                    {error &&
                                        <div className="col-12 user-warn text-center mt-0">
                                            <p> {error} </p>
                                        </div>
                                    }

                                    <div className="col-12">
                                        {!cargando &&
                                            <button
                                                className=""
                                                type="button"
                                                onClick={() => {
                                                    this.register()
                                                }}
                                            >
                                                <i className="far fa-user"></i> Recuperar Contraseña
                                            </button>
                                        }
                                        {cargando &&
                                            <Loading/>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                        {ok &&
                            <div className={"mb-3"}>
                                <p>
                                    Una nueva contraseña ha sido enviada a su casilla de email.
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </>
        )
    }
}
